<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path fill-rule="evenodd" d="M8.94 8.94a1.5 1.5 0 012.12 0L36.5 34.378V18a1.5 1.5 0 013 0v20a1.5 1.5 0 01-1.5 1.5H18a1.5 1.5 0 010-3h16.379L8.939 11.06a1.5 1.5 0 010-2.12z"/></svg>